import Vue from 'vue'
import VueRouter from 'vue-router'

//const FindSitters = () => import ('../components/FindSitters.vue')
import FindSitters from '../components/FindSitters.vue'

//const SitterProfileView = () => import ('../components/Sitters/SitterProfileView.vue')
import SitterProfileView from '../components/Sitters/SitterProfileView.vue'


//const SitterProfileEdit = () => import ('../components/Sitters/SitterProfileEdit.vue')
import SitterProfileEdit from '../components/Sitters/SitterProfileEdit.vue'

import UnSubscribe from '../components/UnSubscribe.vue'

import Home from '../components/Home.vue'


import Chat from '../components/SharedComponents/Chat.vue'
import Signup from '../components/Account/Signup.vue'
import AccountView from '../components/Account/AccountView.vue'
import Login from '../components/Account/Login.vue'
import Success from '../components/Account/Success.vue'
import Subscribe from '../components/Account/Subscribe.vue'
import Cancel from '../components/Account/Cancel.vue'
import PasswordReset from '../components/Account/PasswordReset.vue'
import SitterSignup from '../components/Sitters/SitterSignup.vue'


import Calendar from '../components/Sitters/Profile/Calendar.vue'
import AboutMe from '../components/Sitters/Profile/AboutMe.vue'
import PetPrefs from '../components/Sitters/Profile/PetPrefs.vue'
import ServiceRates from '../components/Sitters/Profile/ServiceRates.vue'

import PetsView from '../components/PetRegistration/PetsView.vue'
import PetRegister from '../components/PetRegistration/components/PetRegister.vue'
import MyPets from '../components/PetRegistration/MyPets.vue'
import MyFavoriteSitters from '../components/Customers/MyFavoriteSitters.vue'
import BecomeSitter from '../components/Sitters/BecomeSitter.vue'
import InitCustomerReservation from '../components/Customers/Reservation/InitReservation.vue'
import ReservationSuccess from '../components/Customers/Reservation/ReservationSuccess.vue'
import MyCustomerReservations from '../components/Customers/Reservation/MyReservations.vue'
import ViewCustomerReservation from '../components/Customers/Reservation/viewReservation.vue'
import MySitterReservations from '../components/Sitters/Reservation/MyReservations.vue'
import ViewSitterReservation from '../components/Sitters/Reservation/ViewSitterReservation.vue'
import ConfirmedReservations from '../components/Sitters/Reservation/components/ConfirmedReservations.vue'
import AdminSitterProfileView from '../components/Admin/components/SitterProfileView.vue'

import CustomerConfirmedReservations from '../components/Customers/Reservation/components/CustomerConfirmedReservations.vue'
import store from '../data/store'
import auth from '../auth/index'
import NotFound from '../components/SharedComponents/NotFound.vue'
import Dashboard from '../components/Sitters/Dashboard.vue'
import FeedbackAndPerformance from '../components/Sitters/FeedbackAndPerformance.vue'
import Shortcuts from '../components/Sitters/Shortcuts.vue'
import ContactSupport from '../components/SharedComponents/ContactSupport.vue'
import AdminLogin from '../components/Admin/AdminLogin.vue'
import SittersDashboard from '../components/Admin/SittersDashboard.vue'
import BookingsDashboard from '../components/Admin/BookingsDashboard.vue'
import UsersDashboard from '../components/Admin/UsersDashboard.vue'
import ChartsDashboard from '../components/Admin/ChartsDashboard.vue'
import CustomEmail from '../components/Admin/CustomEmail.vue'
import TicketsDashboard from '../components/Admin/TicketsDashboard.vue'
import viewReservationAdmin from '../components/Admin/Components/viewReservationAdmin.vue'
import TermsAndConditions from '../components/TermsAndConditions.vue'
import Privacy from '../components/Privacy.vue'

Vue.use(VueRouter)



const router = new VueRouter({
    mode: 'history',
    base: __dirname,
    routes: [
        { name: 'home', path: '/', component: Home },
        { name: 'contact-support', path: '/contact-support/', component: ContactSupport },
        { name: 'become-a-sitter', path: '/become-a-sitter', component: BecomeSitter },
        { name: 'notfound', path: '*', component: NotFound },
        { name: 'signup', path: '/signup', component: Signup },
        {
            name: 'pets-view',
            path: '/pets-view',
            component: PetsView,
            children: [
                { name: 'addPet', path: 'addPet', component: PetRegister },
                { name: 'updatePet', path: 'updatePet/:petId', component: PetRegister },
                { name: 'mypets', path: 'mypets', component: MyPets },
            ],
            beforeEnter: (to, from, next) => {
                auth.checkTokenExpiry()
                if (localStorage.getItem('userRole') != "Client")
                    next({ path: '/login' })
                else
                    next(vm => {

                    })
            }

        },
        { name: 'sitter-signup', path: '/sitter-signup', component: SitterSignup },
        {
            name: 'reservation',
            path: '/reservation/:sitterId',
            component: InitCustomerReservation,
            beforeEnter: (to, from, next) => {
                if (localStorage.getItem('userRole') != "Client")
                    next({ path: '/login' })
                if (from.name != "sitter") {
                    next({ name: 'sitter', params: to.params })
                } else
                    next(vm => {

                    })
            }
        },
        {
            name: 'view-reservation',
            path: '/view-reservation/:reservationId',
            component: ViewCustomerReservation,
            beforeEnter: (to, from, next) => {
                auth.checkTokenExpiry()
                if (localStorage.getItem('userRole') != "Client")
                    next({ path: '/login' })
                else
                    next(vm => {})
            }

        },
        {
            name: 'subscribe',
            path: '/subscribe',
            component: Subscribe,
            beforeEnter: (to, from, next) => {
                auth.checkTokenExpiry()
                if (localStorage.getItem('access_token') == null)
                    next({ path: '/login' })
                else
                    next(vm => {})
            }

        },
        {
            name: 'success',
            path: '/success/:subscriptionId',
            component: Success,
            beforeEnter: (to, from, next) => {
                auth.checkTokenExpiry()
                if (localStorage.getItem('access_token') == null)
                    next({ path: '/login' })
                else
                    next(vm => {})
            }

        },
        {
            name: 'view-sitter-reservation',
            path: '/view-sitter-reservation/:reservationId',
            component: ViewSitterReservation,
            beforeEnter: (to, from, next) => {
                auth.checkTokenExpiry()
                if (localStorage.getItem('userRole') != "Sitter")
                    next({ path: '/login' })
                else
                    next(vm => {})
            }
        },

        {
            name: 'reservation-success',
            path: '/reservation-success',
            component: ReservationSuccess,
            beforeEnter: (to, from, next) => {
                auth.checkTokenExpiry()
                if (localStorage.getItem('userRole') != "Client")
                    next({ path: '/login' })
                else
                    next(vm => {})
            }
        },
        {
            name: 'my-reservations',
            path: '/my-reservations',
            component: MyCustomerReservations,
            beforeEnter: (to, from, next) => {
                auth.checkTokenExpiry()
                if (localStorage.getItem('userRole') != "Client")
                    next({ path: '/login' })
                else
                    next(vm => {})
            }
        },
        {
            name: 'my-sitter-reservations',
            path: '/my-sitter-reservations',
            component: MySitterReservations,
            beforeEnter: (to, from, next) => {
                auth.checkTokenExpiry()
                if (localStorage.getItem('userRole') != "Sitter")
                    next({ path: '/login' })
                else {
                    next(vm => {

                    })
                }


            },
        },

        {
            name: 'dashboard',
            path: '/dashboard',
            component: Dashboard,
            children: [{
                    name: 'feedback-performance',
                    path: 'feedback-performance',
                    component: FeedbackAndPerformance
                },
                {
                    name: 'shortcuts',
                    path: 'shortcuts',
                    component: Shortcuts
                }
            ],
            beforeEnter: (to, from, next) => {
                auth.checkTokenExpiry()
                if (localStorage.getItem('userRole') != "Sitter")
                    next({ path: '/login' })
                if (to.path != '/dashboard/feedback-performance') {
                    next({ path: '/dashboard/feedback-performance' })
                } else {
                    next(vm => {

                    })
                }


            },
        },
        {
            name: 'chat',
            path: '/chat',
            component: Chat,
            beforeEnter: (to, from, next) => {
                auth.checkTokenExpiry()
                if (localStorage.getItem('access_token') == null)
                    next({ path: '/login' })
                else
                    next(vm => {})
            }
        },
        { name: 'unsubscribe', path: '/unsubscribe', component: UnSubscribe },
        { name: 'findSitters', path: '/findsitters', component: FindSitters },
        { name: 'findSittersCity', path: '/findsitters/:cityId', component: FindSitters },
        {
            name: 'account',
            path: '/account',
            component: AccountView,
            beforeEnter: (to, from, next) => {
                auth.checkTokenExpiry()
                if (localStorage.getItem('access_token') == null)
                    next({ path: '/login' })
                else
                    next(vm => {})
            }
        },
        { name: 'sitter', path: '/sitter/:sitterId', component: SitterProfileView },
        { name: 'admin-sitter-view', path: '/admin/:sitterId', component: AdminSitterProfileView },
        {
            path: '/sitter-profile-edit',
            component: SitterProfileEdit,
            children: [
                { path: 'calendar', component: Calendar },
                { path: 'about', component: AboutMe },
                { path: 'petpreferences', component: PetPrefs },
                { path: 'servicerates', component: ServiceRates }
            ],
            beforeEnter: (to, from, next) => {
                auth.checkTokenExpiry()
                if (localStorage.getItem('userRole') != "Sitter")
                    next({ path: '/login' })
                else {
                    next(vm => {

                    })
                }


            },
        },
        { name: 'login', path: '/login', component: Login },
        { name: 'cancel', path: '/cancel', component: Cancel },
        { name: 'favorite-sitters', path: '/favorite-sitters', component: MyFavoriteSitters },
        { name: 'passwordReset', path: '/passwordReset', component: PasswordReset },
        { name: 'default', path: '*', redirect: '/home' },
        { name: 'adminLogin', path: '/admin', component: AdminLogin },
        { name: 'sitters-dashboard', path: '/sitters-dashboard', component: SittersDashboard },
        { name: 'bookings-dashboard', path: '/bookings-dashboard', component: BookingsDashboard },
        { name: 'users-dashboard', path: '/users-dashboard', component: UsersDashboard },
        { name: 'charts-dashboard', path: '/charts-dashboard', component: ChartsDashboard },
        { name: 'email-dashboard', path: '/email-dashboard', component: CustomEmail },
        { name: 'tickets-dashboard', path: '/tickets-dashboard', component: TicketsDashboard },
        { name: 'view-admin-reservation', path: '/view-admin-reservation/:reservationId', component: viewReservationAdmin },
        { name: 'terms-and-conditions', path: '/terms-and-conditions', component: TermsAndConditions },
        { name: 'privacy-policy', path: '/privacy-policy', component: Privacy },

    ],



    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }

    }
})

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js